import React, { useState, useEffect, Fragment } from 'react';
import { ProductQuantityConstants } from '../constants';
import { translate } from '../Services/translation';

const ProductQuantityField = (props) => {
    const defaultQuantity = parseInt(props.minArticleQuantity) ?? 1;

    useEffect(() => {
        document.getElementById(ProductQuantityConstants.QuantityId).value = defaultQuantity;
      }, []);

    const [quantity, setQuantity] = useState(defaultQuantity);

    const setQuantityInputField = (newValue) => {
        document.getElementById(ProductQuantityConstants.QuantityId).value = newValue;
    };

    const increaseQuantity = () => {
        setQuantity((x) => x + defaultQuantity);
        setQuantityInputField(quantity+defaultQuantity);
    };

    const decreaseQuantity = () => {
        if (quantity > defaultQuantity) {
            setQuantity((x) => x - defaultQuantity);
            setQuantityInputField(quantity-defaultQuantity);
        }
    };

    return (
        <Fragment>            
            <button type="button"
                className={`${ProductQuantityConstants.ProductDetailQuantityButton} left`}
                onClick={decreaseQuantity}
                aria-label={translate('general.decreasequantity')}>
                    {ProductQuantityConstants.MinusSign}
            </button>
            <p  id={ProductQuantityConstants.QuantityId} 
                value={defaultQuantity}
                className={ProductQuantityConstants.ProductDetailQuantityInput}>
                    {quantity}
            </p>
            <button type="button"
                className={`${ProductQuantityConstants.ProductDetailQuantityButton} right`}
                onClick={increaseQuantity}
                aria-label={translate('general.increasequantity')}>
                    {ProductQuantityConstants.PlusSign}
            </button>
        </Fragment>
    );
};

export default ProductQuantityField;